import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
// import * as styles from "./TelegramModal.module.scss";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
const TelegramModal = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        const dateNow = new Date().getTime();
        setStoredDate(dateNow + storedDays.current);
        localStorage.setItem('storedDate', (dateNow + storedDays.current).toString());
        setShow(false);
    };
    const telegramUrl = useRef("https://t.me/stktaganrog");
    const handleShow = () => setShow(true);
    const storedDays = useRef(30 * 24 * 60 * 60 * 1000);
    const [reseted, setReseted] = useState(false);
    const [storedDate, setStoredDate] = useState(null);
    const determineShow = () => {
        const dateNow = new Date().getTime();
        const urlParams = new URLSearchParams(window.location.search);
        const isReset = urlParams.get('resetDate');
        if (isReset && reseted === false) {
            localStorage.removeItem('storedDate');
            setStoredDate(null);
            setShow(true);
            setReseted(true);
        }
        else {
            if (storedDate !== null && dateNow >= storedDate) {
                localStorage.removeItem('storedDate');
                setStoredDate(null);
                setShow(true);
            }
            else if (storedDate === null) {
                setShow(true);
            }
            else {
                setShow(false);
            }
        }
    };
    useEffect(() => {
        determineShow();
    }, [storedDate]);
    useEffect(() => {
        setStoredDate(localStorage.getItem('storedDate') !== undefined && parseInt(localStorage.getItem('storedDate')) > 0
            ? parseInt(localStorage.getItem('storedDate'))
            : null);
    }, []);
    return (_jsx("div", { style: { display: "none" }, children: _jsxs(Modal, { show: show, onHide: handleClose, backdrop: "static", keyboard: false, size: "lg", centered: true, children: [_jsx(Modal.Header, { closeButton: true, className: "bg-primary", children: _jsxs(Modal.Title, { className: "text-white", children: [_jsx(FontAwesomeIcon, { size: "xl", icon: faTelegram }), _jsx("span", { className: "ms-4", children: "\u0411\u0443\u0434\u044C \u0432 \u043A\u0443\u0440\u0441\u0435" })] }) }), _jsx(Modal.Body, { children: _jsx(Container, { fluid: true, children: _jsxs(Row, { className: "align-items-center justify-content-start", children: [_jsx(Col, { xs: 12, md: 6, children: _jsxs("p", { className: "h6", children: [_jsx("a", { href: telegramUrl.current, target: "_blank", rel: "noopener noreferrer", onClick: handleClose, children: "\u041F\u043E\u0434\u043F\u0438\u0448\u0438\u0441\u044C" }), " \u043D\u0430 \u043D\u0430\u0448 Telegram"] }) }), _jsx(Col, { xs: 12, md: 6, children: _jsx(Image, { src: "/upload/images/png/stktagtelegramqr.png", rounded: true }) })] }) }) }), _jsxs(Modal.Footer, { children: [_jsx("a", { href: telegramUrl.current, target: "_blank", rel: "noopener noreferrer", onClick: handleClose, className: "btn btn-success", children: "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F" }), _jsx(Button, { variant: "secondary", onClick: handleClose, children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" })] })] }) }));
};
export default TelegramModal;
